module.exports = __webpack_public_path__ + "img/how-it-works-thumb.41c2d13.webp";